/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SyncTrackFeaturesResponseDto interface.
 */
export function instanceOfSyncTrackFeaturesResponseDto(value) {
    if (!('synced' in value) || value['synced'] === undefined)
        return false;
    if (!('failed' in value) || value['failed'] === undefined)
        return false;
    return true;
}
export function SyncTrackFeaturesResponseDtoFromJSON(json) {
    return SyncTrackFeaturesResponseDtoFromJSONTyped(json, false);
}
export function SyncTrackFeaturesResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'synced': json['synced'],
        'failed': json['failed'],
    };
}
export function SyncTrackFeaturesResponseDtoToJSON(json) {
    return SyncTrackFeaturesResponseDtoToJSONTyped(json, false);
}
export function SyncTrackFeaturesResponseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'synced': value['synced'],
        'failed': value['failed'],
    };
}
